<template>
  <div>
    <div class="row">
      <div class="col col-md-4">
        <div :class="{'sr-only': srOnlyLabel}">
          <label :for="$attrs.id" class="a-select-label">Search Groups</label>
        </div>
        <a-select
            :id="$attrs.id"
            :options="options"
            :selectedOptionIds="completerIds"
            bind-by-object
            multiselect
            placeholder="Search to add groups..."
            compress
            @input="createAssignee"
            @destroy="destroyAssignee"
        ></a-select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <template v-for="permittee in permittees">
          <pill
              :class="$attrs.id"
              :color="pillColor(permittee)"
              @onRemove="removeAssignee(permittee)"
              :value="permittee.display"
          >
            <template #suffix v-if="permittee.legacyConfigTooltip">
              <button type="button" class="btn-icon" v-tooltip="permittee.legacyConfigTooltip">
                <icon class="exclamation"></icon>
                <span class="sr-only">{{ permittee.legacyConfigTooltip }}</span>
              </button>
            </template>
          </pill>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import assignableMixin from "~/mixins/assignableMixin";
import {IPermittee} from "~/interfaces/permitteeInterfaces";
import {TVOptionSet} from "../../../common/interfaces/vSelectInterfaces";
import {PermitteeType} from "~/enums/permitteeType";
import {TagColor} from "~/enums/tagColor";

export default Vue.extend({
  inheritAttrs: false,
  mixins: [assignableMixin],
  props: {
    permittees: {
      type: Array as () => IPermittee[],
    },
    options: {
      type: Array as () => TVOptionSet[],
    },
    srOnlyLabel: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      PermitteeType,
    };
  },
  computed: {
    completerIds: {
      get(): string[] {
        return this.permittees.map(p => p.reference_id);
      },
    },
    assigneeCollection(): IPermittee[] {
      return this.permittees;
    },
  },
  methods: {
    createAssignee(option): void {
      this.$emit('create', this.getAssigneePropsFromOption(option));
    },
    removeAssignee(permittee: IPermittee): void {
      this.$emit('remove', permittee);
    },
    pillColor(permittee: IPermittee): string {
      return TagColor[permittee.reference_type];
    }
  },
});
</script>